import {
  Button,
  Card,
  CardActions,
  CardContent,
  CircularProgress,
  Typography,
} from '@mui/material';
import { FunctionComponent } from 'react';
import { useNavigate } from 'react-router-dom';

import { Layout } from '../../../navigation/components/Layout/Layout';
import { HeaderCard } from '../../components/HeaderCard';
import { useCurrentEventQuery } from '../../hooks/useCurrentEventQuery';

export const PaymentError: FunctionComponent = () => {
  const navigate = useNavigate();
  const { loading } = useCurrentEventQuery();

  const onGoToPayment = () => {
    navigate('/payment');
  };

  return (
    <Layout title="Erreur du paiement" activeTab="payment" headerType="error">
      {loading ? (
        <CircularProgress />
      ) : (
        <>
          <HeaderCard />
          <Card>
            <CardContent>
              <Typography variant="h6">
                {
                  'Une erreur est survenue lors du paiement avec Hello Asso. Cela peut être dû à votre banque.'
                }
              </Typography>
              <Typography variant="subtitle1">
                {'Veuillez réessayer. Si le problème persiste, contactez-nous.'}
              </Typography>
            </CardContent>
            <CardActions>
              <Button variant="contained" onClick={onGoToPayment}>
                Retourner au paiement
              </Button>
            </CardActions>
          </Card>
        </>
      )}
    </Layout>
  );
};
